var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "help_svg__mask0_14018_10472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#help_svg__mask0_14018_10472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75C7.07107 8.75 8.75 7.07107 8.75 5C8.75 2.92893 7.07107 1.25 5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75Z",
    stroke: "#4957F2",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41683 6.55339C5.41683 6.32327 5.23028 6.13672 5.00016 6.13672C4.77004 6.13672 4.5835 6.32327 4.5835 6.55339C4.5835 6.7835 4.77004 6.97005 5.00016 6.97005C5.23028 6.97005 5.41683 6.7835 5.41683 6.55339Z",
    fill: "#4957F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97705 4.11408C3.97705 3.63681 4.41777 3.2959 4.98261 3.2959C5.54745 3.2959 5.96437 3.61408 5.96437 4.09135C5.96437 4.65953 4.99978 4.77317 4.98261 5.34135C4.98261 5.34135 4.98261 5.49287 4.98261 5.56863",
    stroke: "#4957F2",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgHelp;